module.exports = __webpack_public_path__ + "img/p3.baf4d317.png";